import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const getAllUnits = async (businessId?: string): Promise<any> => {
  try {
    const userId = getUserId();
    if (!userId) throw new Error("User ID not found. Please log in again.");
    
    let url = `/units/getall/${businessId}`;
   
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCurrency = async (branchData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/Currencys/create", branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCurrency = async (
  id: string,
  branchData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/Currencys/${id}`, branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCurrency = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/Currencys/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
